import { useEffect, useRef, useState } from 'react'

/**
 * Renders Mermaid diagram code. Falls back to pre/code if mermaid fails or not installed.
 */
export default function MermaidDiagram({ code, className = '' }) {
  const containerRef = useRef(null)
  const [error, setError] = useState(false)
  const [svg, setSvg] = useState(null)

  useEffect(() => {
    if (!code || !code.trim()) {
      setError(true)
      return
    }
    let cancelled = false
    import('mermaid').then((mod) => {
      if (cancelled) return
      const mermaid = mod.default
      mermaid.initialize({ startOnLoad: false })
      const codeClean = code.replace(/^```\w*\n?|```$/g, '').trim()
      const id = `mermaid-${Math.random().toString(36).slice(2, 9)}`
      mermaid.render(id, codeClean).then(({ svg: s }) => {
        if (!cancelled) setSvg(s)
      }).catch(() => {
        if (!cancelled) setError(true)
      })
    }).catch(() => {
      if (!cancelled) setError(true)
    })
    return () => { cancelled = true }
  }, [code])

  if (error || !code?.trim()) {
    return (
      <pre className={`bg-slate-100 p-4 rounded-lg overflow-x-auto text-sm ${className}`}>
        <code>{code || '(No diagram)'}</code>
      </pre>
    )
  }

  if (svg) {
    return <div ref={containerRef} className={className} dangerouslySetInnerHTML={{ __html: svg }} />
  }
  return <div className={`animate-pulse bg-slate-100 rounded h-48 ${className}`} />
}
